// Sprint T-22 · NotificationEmptyState · estado vacío contextual
import React from "react";
import { BellSlash, MagnifyingGlass, CheckCircle } from "@phosphor-icons/react";

/**
 * Estado vacío contextual · el mensaje depende de los filtros activos:
 *   · unread_only=true  → “Sin notificaciones sin leer”
 *   · q (búsqueda)      → “Sin resultados para tu búsqueda”
 *   · kind seleccionado → “Sin notificaciones en esta categoría”
 *   · default           → “Todo al día · sin notificaciones”
 */
export const NotificationEmptyState = ({
  unreadOnly = false,
  hasSearch = false,
  hasKindFilter = false,
}) => {
  let Icon = CheckCircle;
  let title = "Todo al día";
  let hint = "No tienes notificaciones nuevas por ahora.";

  if (hasSearch) {
    Icon = MagnifyingGlass;
    title = "Sin resultados";
    hint = "Prueba con otras palabras o quita algún filtro.";
  } else if (unreadOnly) {
    Icon = CheckCircle;
    title = "Sin notificaciones sin leer";
    hint = "Has leído todas las notificaciones. ¡Buen trabajo!";
  } else if (hasKindFilter) {
    Icon = BellSlash;
    title = "Sin notificaciones en esta categoría";
    hint = "Prueba con otra categoría o consulta “Todas”.";
  }

  return (
    <div
      className="px-6 py-14 flex flex-col items-center justify-center text-center"
      data-testid="notif-empty-state"
    >
      <div className="w-14 h-14 rounded-full bg-[var(--ag-midnight)]/60 border border-[var(--ag-border)]/60 flex items-center justify-center mb-4">
        <Icon size={26} className="text-[var(--ag-text-dim)]" />
      </div>
      <div className="text-sm font-semibold text-white mb-1">{title}</div>
      <div className="text-xs text-[var(--ag-text-dim)] max-w-[280px]">{hint}</div>
    </div>
  );
};

export default NotificationEmptyState;
